import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';

const styles = StyleSheet.create({
  container: {
    borderColor: '#dedede',
    borderWidth: 1,
    borderRadius: 5,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#ffffff',
  },
  text: {
    color: '#3a3a3a',
    textAlign: 'center',
    verticalAlign: 'auto',
  },
});

export function LetterSquare({ letter, isEmpty, size, marginLeft }) {
  const responsiveStylesForLetter = StyleSheet.create({
    blankedText: {
      fontSize: size / 1.35,
    },
    blankedLetterWrapperStyle: {
      width: size,
      height: size,
      marginLeft: marginLeft,
    },
  });

  return (
    <View
      style={[
        !isEmpty && styles.container,
        responsiveStylesForLetter.blankedLetterWrapperStyle,
      ]}
    >
      {isEmpty ? null : (
        <Text
          className="font-abz"
          style={[styles.text, responsiveStylesForLetter.blankedText]}
        >
          {letter}
        </Text>
      )}
    </View>
  );
}
